import { pipe, tap } from 'wonka'
import { Exchange, CombinedError } from 'urql'

/**
 * Use this exchange to handle errors from the server.
 *
 * This is useful for logging errors or displaying them to the user.
 *
 * @param onError A callback to call when an error is encountered
 * @returns An exchange that handles errors from the server
 */
export const createErrorExchange =
  (onError: (error: CombinedError) => void): Exchange =>
  ({ forward }) =>
  (ops$) =>
    pipe(
      forward(ops$),
      tap(({ error }) => {
        if (error) {
          onError(error)
        }
      })
    )
